import request from '@/utils/request/request'

export function order(data) {
  return request({
    url: '/v1/order',
    method: 'post',
    data
  })
}


export function order_status(data) {
  return request({
    url: '/v1/order_status',
    method: 'get',
    data
  })
}

export function order_detail(data) {
  return request({
    url: '/v1/order_detail',
    method: 'get',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/pay.js